// extracted by mini-css-extract-plugin
module.exports = {"interactiveTextStyles":"components-InteractiveText-styles__interactiveTextStyles"};